import withToasted from "@/mixins/withToasted";

export default {
  mixins: [withToasted],
  methods: {
    copy(text) {
      this.$copyText(text).then(
        () => {
          this.toast("Copied!", "success", { icon: "check" });
        },
        () => {
          this.toast("Copied!", "error", { icon: "times" });
        }
      );
    }
  }
};
